<div
    *ngIf="visible"
    [class.modal--scrollable]="scrollable"
    class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
    (click)="close.emit()"
    (keydown.escape)="close.emit()"
    tabindex="0"
    role="dialog"
    aria-modal="true"
>
    <div
        class="modal-panel bg-white rounded-lg shadow-xl max-w-sm sm:max-w-md w-full mx-2 sm:mx-4"
        (click)="$event.stopPropagation()"
        (keydown.escape)="$event.stopPropagation()"
        tabindex="0"
    >
        <ng-content></ng-content>
    </div>
</div>
